import { isCommercial, offerTypeFromJsonQuery } from '../../packages/JsonQuery';
import { IAppState } from '../common/state';
import { selectJsonQuery } from './results/selectJsonQuery';

export const selectIsCommercial = (state: IAppState): boolean =>
  isCommercial(offerTypeFromJsonQuery(selectJsonQuery(state)));
